<template>
  <div class="notification-item">
    <!-- If the icon is an image, display it -->
    <img v-if="icon" :src="icon" alt="Notification Icon" class="notification-icon" />

    <div class="content">
      <h4 class="custom-14px-500 font-color-171717">{{ title }}</h4>
      <p class="custom-12px-400">{{ message }}</p>
      <span class="time">{{ time }}</span>
      
      <!-- Optional additional image -->
      <img v-if="image" :src="image" alt="Notification image" class="notification-image" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String, // Now used for images
    title: String,
    time: String,
    message: String,
    image: String, // Optional additional image
  },
};
</script>

<style scoped>
.notification-item {
  display: flex;
  align-items: flex-start; /* Align icon to the top */
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.notification-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  margin-top: 5px; /* Add margin to move it slightly down if needed */
}


.content {
  flex-grow: 1;
}

h4 {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
}

p {
  font-size: 12px;
  color: #666;
  margin: 5px 0;
}

.time {
  font-size: 10px;
  color: #aaa;
}

.notification-image {
  width: 100%;
  max-width: 150px;
  border-radius: 8px;
  margin-top: 10px;
}
</style>